import * as React from 'react';

import FaceIdIconBase from '../../../Icons/FaceIdIcon';
import FingerprintIconBase from '../../../Icons/FingerprintIcon';
import GenericBiometricIconBase from '../../../Icons/GenericBiometricIcon';
import PasscodeIconBase from '../../../Icons/PasscodeIcon';
import QuickLoginIconBase from '../../../Icons/QuickLoginIcon';

import styles from './styles.scss';

export function FaceIdIcon({ className }: { className?: string }) {
  return (
    <FaceIdIconBase
      className={className}
      pathClassName={styles.faceIdIconPath}
    />
  );
}

export function FingerprintIcon({ className }: { className?: string }) {
  return (
    <FingerprintIconBase
      className={className}
      pathClassName={styles.fingerprintIconPath}
    />
  );
}

export function GenericBiometricIcon({ className }: { className?: string }) {
  return (
    <GenericBiometricIconBase
      className={className}
      pathClassName={styles.genericBiometricIconPath}
    />
  );
}

export function PasscodeIcon({ className }: { className?: string }) {
  return <PasscodeIconBase className={className} />;
}

export function QuickLoginIcon({ className }: { className?: string }) {
  return (
    <QuickLoginIconBase
      className={className}
      pathClassName={styles.quickLoginIconPath}
    />
  );
}
